import * as React from 'react';
import { Button } from 'vet-bones/design-system/components';

import { useAppSelector } from 'src/ui/app/hooks';
import { withConfirmationDs } from 'src/ui/components/withConfirmationDs';
import { noop } from 'src/ui/constants/empty';
import { InstanceFlavors } from 'src/ui/features/connection';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import {
  Connection as GraphConnection,
  useGetStripeSessionUrlMutation,
} from 'src/ui/graph/types';
import { userIdSelector } from 'src/ui/selectors/userId';
import { components } from 'src/ui/templates/copy';
import { redirectToUrl } from 'src/ui/utils/window';

interface ServerOverviewButtonProps {
  connection: GraphConnection | null | undefined;
}

export const ServerOverviewButton: React.VFC<ServerOverviewButtonProps> = ({
  connection,
}) => {
  const userId = useAppSelector(userIdSelector());
  const { mutate: billingMutate } = useGetStripeSessionUrlMutation(
    graphQLClient,
    {
      onSuccess: (data) => {
        redirectToUrl(data?.getStripeSessionUrl?.url || '/');
      },
    }
  );

  const handleBillingRedirect = () => billingMutate({});
  const handleContactOwner = () => {
    withConfirmationDs({
      isCloseButtonShown: false,
      message: components.contactOwnerDialog.body(
        connection?.cloud?.owner?.email || null
      ),
      noPrompt: null,
      onConfirmationSuccess: noop,
      title: components.contactOwnerDialog.title,
      yesPrompt: components.contactOwnerDialog.buttonText,
    });
  };

  const isEssentials =
    connection?.cloud?.flavor?.name === InstanceFlavors.SMALL_VBX ||
    connection?.cloud?.flavor?.name === InstanceFlavors.SMALL;
  const isFree = connection?.isStardogFree;
  const isUserCloudOwner = userId && userId === connection?.cloud?.owner?.id;

  if (!connection || (!(isFree && isUserCloudOwner) && !isEssentials)) {
    return null;
  }

  let text = '';
  let onClick = noop;

  if (isFree && !isEssentials) {
    return null;
  }

  if (isUserCloudOwner) {
    onClick = handleBillingRedirect;
    text = components.ServerOverview.button.manageBilling;
  } else {
    onClick = handleContactOwner;
    text = components.ServerOverview.button.contactOwner;
  }

  return (
    <Button onClick={onClick} size="sm" variant="tertiary-gray">
      {text}
    </Button>
  );
};
